import React from 'react';
var WindowReadonlyContext = React.createContext(null);
export var WindowReadonlyProvider = WindowReadonlyContext.Provider;
export var WindowReadonlyConsumer = WindowReadonlyContext.Consumer;
export default WindowReadonlyContext;
//# sourceMappingURL=window-readonly-context.js.map